import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { MessageCirclePlus } from "@/components/icons"
import { useRoutes } from "@/contexts/use-routes"
import { cn } from "@/lib/utils"

import { buttonVariants } from "../../../components/ui/button-variants"
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../components/ui/tooltip"

type StartNewChatProps = {
  onStartNewChatClick: () => void
  tooltipText?: string
  navigateOnSelect?: boolean
  className?: string
}

export function StartNewChat({
  onStartNewChatClick,
  tooltipText,
  navigateOnSelect = false,
  className,
}: StartNewChatProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { routes } = useRoutes()
  const defaultRoute = routes.find((r) => r.default_route)
  const homePath = defaultRoute?.path ?? "/explorer"

  return (
    <Tooltip>
      <TooltipTrigger
        data-testid="start-new-chat-button"
        className={cn(
          buttonVariants({
            size: "icon",
            variant: "ghost",
            className: cn(
              "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground size-10 shrink-0 items-center justify-center rounded-md transition-[color,background-color,scale] duration-200 active:scale-[0.99]",
              className
            ),
          })
        )}
        onClick={() => {
          onStartNewChatClick()
          if (navigateOnSelect) {
            void navigate(homePath)
          }
        }}
      >
        <MessageCirclePlus className="size-6 shrink-0 transition-colors" />
      </TooltipTrigger>
      <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
        <p>{tooltipText ?? t("questioninput.start_new_chat")}</p>
      </TooltipContent>
    </Tooltip>
  )
}
